// @flow
export var _SUCCESS = '_SUCCESS';
export var _LOADING = '_LOADING';
export var RESET_STORE = 'RESET_STORE';
export var EXPIRED_JWT = 'EXPIRED_JWT';
export var BAD_ENCRYPTION_KEY = 'BAD_ENCRYPTION_KEY';
export var CLEAR_SESSION = 'CLEAR_SESSION';
export var CRUD_LOADING = 'CRUD_LOADING';
export var CRUD_FAILURE = 'CRUD_FAILURE';
export var RESET_CRUD_ERROR = 'RESET_CRUD_ERROR';
export var CREATED = 'CREATED';
export var DELETED = 'DELETED';
export var JOIN = 'JOIN';
export var LEAVE = 'LEAVE';
export var UPDATED = 'UPDATED';
export var USERS_LIST = 'USERS_LIST';
export var SET_ITEM = 'SET_ITEM';
export var SET_ITEMS = 'SET_ITEMS';
export var CONCAT_ITEMS = 'CONCAT_ITEMS';
export var FILTER_ITEMS = 'FILTER_ITEMS';
export var ADD_LOADING = 'ADD_LOADING';
export var REMOVE_LOADING = 'REMOVE_LOADING';
export var ADD_ERROR = 'ADD_ERROR';
export var REMOVE_ERROR = 'REMOVE_ERROR';
export var READ_ERROR = 'READ_ERROR';
export var GET_LIST = 'GET_LIST';
export var GET_ONE = 'GET_ONE';
export var GET_MANY = 'GET_MANY';
export var GET_MANY_REFERENCE = 'GET_MANY_REFERENCE';
export var CREATE = 'CREATE';
export var CREATE_MANY = 'CREATE_MANY';
export var UPLOAD = 'UPLOAD';
export var PATCH = 'PATCH';
export var UPDATE = 'UPDATE';
export var UPDATE_MANY_POST = 'UPDATE_MANY_POST';
export var UPDATE_MANY = 'UPDATE_MANY';
export var DELETE = 'DELETE';
export var DELETE_MANY = 'DELETE_MANY';
export var DELETE_MANY_POST = 'DELETE_MANY_POST';
export var RESET = 'RESET';
export var REVERT = 'REVERT';
export var ACKNOWLEDGE = 'ACKNOWLEDGE';
export var DOWNLOAD = 'DOWNLOAD';
export var UPLOAD_MANY = 'UPLOAD_MANY';
export var GET_LIST_SUCCESS = "".concat(GET_LIST).concat(_SUCCESS);
export var GET_LIST_LOADING = "".concat(GET_LIST).concat(_LOADING);
export var GET_ONE_SUCCESS = "".concat(GET_ONE).concat(_SUCCESS);
export var GET_ONE_LOADING = "".concat(GET_ONE).concat(_LOADING);
export var GET_MANY_SUCCESS = "".concat(GET_MANY).concat(_SUCCESS);
export var GET_MANY_LOADING = "".concat(GET_MANY).concat(_LOADING);
export var GET_MANY_REFERENCE_SUCCESS = "".concat(GET_MANY_REFERENCE).concat(_SUCCESS);
export var GET_MANY_REFERENCE_LOADING = "".concat(GET_MANY_REFERENCE).concat(_LOADING);
export var CREATE_SUCCESS = "".concat(CREATE).concat(_SUCCESS);
export var CREATE_LOADING = "".concat(CREATE).concat(_LOADING);
export var CREATE_MANY_SUCCESS = "".concat(CREATE_MANY).concat(_SUCCESS);
export var CREATE_MANY_LOADING = "".concat(CREATE_MANY).concat(_LOADING);
export var PATCH_SUCCESS = "".concat(PATCH).concat(_SUCCESS);
export var PATCH_LOADING = "".concat(PATCH).concat(_LOADING);
export var UPLOAD_SUCCESS = "".concat(UPLOAD).concat(_SUCCESS);
export var UPLOAD_LOADING = "".concat(UPLOAD).concat(_LOADING);
export var UPDATE_SUCCESS = "".concat(UPDATE).concat(_SUCCESS);
export var UPLOAD_MANY_SUCCESS = "".concat(UPLOAD_MANY).concat(_SUCCESS);
export var UPLOAD_MANY_LOADING = "".concat(UPLOAD_MANY).concat(_LOADING);
export var UPDATE_LOADING = "".concat(UPDATE).concat(_LOADING);
export var UPDATE_MANY_SUCCESS = "".concat(UPDATE_MANY).concat(_SUCCESS);
export var UPDATE_MANY_POST_SUCCESS = "".concat(UPDATE_MANY_POST).concat(_SUCCESS);
export var UPDATE_MANY_LOADING = "".concat(UPDATE_MANY).concat(_LOADING);
export var DELETE_MANY_POST_SUCCESS = "".concat(DELETE_MANY_POST).concat(_SUCCESS);
export var DELETE_SUCCESS = "".concat(DELETE).concat(_SUCCESS);
export var DELETE_LOADING = "".concat(DELETE).concat(_LOADING);
export var DELETE_MANY_SUCCESS = "".concat(DELETE_MANY).concat(_SUCCESS);
export var DELETE_MANY_LOADING = "".concat(DELETE_MANY).concat(_LOADING);
export var REVERT_LOADING = "".concat(REVERT).concat(_LOADING);
export var REVERT_SUCCESS = "".concat(REVERT).concat(_SUCCESS);
export var LOGIN = 'LOGIN';
export var AUTH = 'AUTH';
export var AUTH_LOGIN = 'LOGIN';
export var AUTH_REGISTER = 'REGISTER';
export var AUTH_LOGOUT = 'LOGOUT';
export var AUTH_LOADING = 'AUTH_LOADING';
export var AUTH_SUCCESS = 'AUTH_SUCCESS';
export var AUTH_FAILURE = 'AUTH_FAILURE';
export var AUTH_CURRENT_USER = 'AUTH_CURRENT_USER';
export var WS_CONNECT = 'WS_CONNECT';
export var WS_RECONNECT = 'WS_RECONNECT';
export var WS_RECONNECTING = 'WS_RECONNECTING';
export var WS_FAILURE = 'WS_FAILURE';
export var WS_CONNECT_SUCCESS = 'WS_CONNECT_SUCCESS';
export var WS_AUTHENTICATE_SUCCESS = 'WS_AUTHENTICATE_SUCCESS';
export var WS_AUTHENTICATE_FAILURE = 'WS_AUTHENTICATE_FAILURE';
export var WS_RECONNECT_SUCCESS = 'WS_RECONNECT_SUCCESS';
export var WS_DISCONNECT = 'WS_DISCONNECT';
export var WS_DISCONNECT_SUCCESS = 'WS_DISCONNECT_SUCCESS';
export var AUTHENTICATE = 'AUTHENTICATE';
export var ANNOUNCEMENT = 'ANNOUNCEMENT';
export var WS_LOGOUT = 'WS_LOGOUT';
export var LEAVE_ROOM = 'LEAVE_ROOM';
export var JOIN_ROOM = 'JOIN_ROOM';
export var SEND_MESSAGE = 'SEND_MESSAGE';
export var LEAVE_ROOM_SUCCESS = "".concat(LEAVE_ROOM).concat(_SUCCESS);
export var JOIN_ROOM_SUCCESS = "".concat(JOIN_ROOM).concat(_SUCCESS);
export var SEND_MESSAGE_SUCCESS = "".concat(SEND_MESSAGE).concat(_SUCCESS);
export var AUTH_RESET_PASSWORD = 'PASSWORD-RESETS';
export var AUTH_REQUEST_PASSWORD = 'PASSWORD-REQUESTS';
export var AUTH_REQUEST_PASSWORD_SUCCESS = "".concat(AUTH_REQUEST_PASSWORD).concat(_SUCCESS);
export var AUTH_CHANGE_PASSWORD = 'PASSWORD-CHANGES';
export var AUTH_CHANGE_PASSWORD_SUCCESS = "".concat(AUTH_CHANGE_PASSWORD).concat(_SUCCESS);
export var SEARCH_ADDRESS_LOADING = 'SEARCH_ADDRESS_LOADING';
export var SEARCH_ADDRESS = 'SEARCH_ADDRESS';
export var SEARCH_ADDRESS_FAILURE = 'SEARCH_ADDRESS_FAILURE';
export var SEARCH_ADDRESS_SUCCESS = 'SEARCH_ADDRESS_SUCCESS';
export var REVERSE_ADDRESS_LOADING = 'REVERSE_ADDRESS_LOADING';
export var REVERSE_ADDRESS = 'REVERSE_ADDRESS';
export var REVERSE_ADDRESS_FAILURE = 'REVERSE_ADDRESS_FAILURE';
export var REVERSE_ADDRESS_SUCCESS = 'REVERSE_ADDRESS_SUCCESS';
export var ADDRESS_SET_ITEM = 'ADDRESS_SET_ITEM';
export var ADDRESS_SET_ITEMS = 'ADDRESS_SET_ITEMS';
export var ADDRESS_MERGE_ITEM = 'ADDRESS_MERGE_ITEM';
export var SUGGEST_SEARCH = 'SUGGEST_SEARCH';
export var SUGGEST_SEARCH_LOADING = 'SUGGEST_SEARCH_LOADING';
export var SUGGEST_SEARCH_SUCCESS = 'SUGGEST_SEARCH_SUCCESS';
export var SUGGEST_SEARCH_FAILURE = 'SUGGEST_SEARCH_FAILURE';
export var SUGGEST_SET_ITEM = 'SUGGEST_SET_ITEM';
export var SUGGEST_SET_ITEMS = 'SUGGEST_SET_ITEMS';
export var SEARCH_ADDRESS_BACKUP = 'SEARCH_ADDRESS_BACKUP';
export var REVERSE_ADDRESS_BACKUP = 'REVERSE_ADDRESS_BACKUP';
export var SUGGEST_SEARCH_VIA_BACKEND = 'SUGGEST_SEARCH_VIA_BACKEND';
export var SUGGEST_RESET = 'SUGGEST_RESET';
export var HEALTH_CHECK_FRONT_PATIENT = 'FRONT_PATIENT';
export var HEALTH_CHECK_FRONT_PATIENT_ENCRYPTION = 'FRONT_PATIENT_ENCRYPTION';
export var FRONT_PATIENT_ADDRESS_SERVER = 'FRONT_PATIENT_ADDRESS_SERVER';
export var FRONT_PATIENT_MAP_SERVER = 'FRONT_PATIENT_MAP_SERVER';
export var HEALTH_CHECK_ACCOUNT_CREATION_PRO = 'SIGNUP_ACCOUNT_CREATION';
export var HEALTH_CHECK_IDENTITY_VERIFICATION_PRO = 'SIGNUP_IDENTITY_VERIFICATION';
export var HEALTH_CHECK_FRONT_PRO = 'FRONT_PRO';
export var FRONT_PRO_ADDRESS_SERVER = 'FRONT_PRO_ADDRESS_SERVER';
export var restActions = [GET_ONE, GET_LIST, UPDATE_MANY, CREATE, CREATE_MANY, UPLOAD, UPLOAD_MANY, UPDATE, PATCH, UPDATE_MANY_POST, DELETE, DELETE_MANY_POST, SUGGEST_SEARCH, SEARCH_ADDRESS, REVERSE_ADDRESS, REVERT, DOWNLOAD];
//# sourceMappingURL=constants.js.map